'use client'

import { useState, useEffect } from 'react'

// Phase B1：token 改存 httpOnly cookie，JS 讀不到（防 XSS）。
// sessionStorage TOKEN_KEY 留作過渡期 fallback：舊登入狀態升級時不要強制重登。
const LEGACY_TOKEN_KEY = 'meowmi-admin-token'

export default function PasswordGate({ children }) {
  const [authenticated, setAuthenticated] = useState(false)
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(true)
  const [verifying, setVerifying] = useState(false)

  // 檢查 admin token 是否有效（cookie 由瀏覽器自動帶，不需 JS 操作）
  // 舊版 sessionStorage token 仍透過 header fallback 過渡（B1 後可移除）
  useEffect(() => {
    const legacy = sessionStorage.getItem(LEGACY_TOKEN_KEY)
    fetch('/api/auth/check', {
      method: 'POST',
      credentials: 'include', // 帶 httpOnly cookie
      headers: legacy ? { 'x-admin-token': legacy } : {},
    })
      .then((res) => {
        if (res.ok) setAuthenticated(true)
      })
      .catch(() => {})
      .finally(() => setLoading(false))
  }, [])

  const handleSubmit = async (e) => {
    e.preventDefault()
    setVerifying(true)
    setError('')
    try {
      const res = await fetch('/api/auth/verify', {
        method: 'POST',
        credentials: 'include', // server 會 Set-Cookie httpOnly
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password }),
      })
      const data = await res.json()
      if (data.valid) {
        // server 已透過 Set-Cookie 寫 httpOnly cookie
        // 過渡期：response body 仍含 token，存 sessionStorage 給舊 lib/artworkApi.js fallback
        if (data.token) sessionStorage.setItem(LEGACY_TOKEN_KEY, data.token)
        setAuthenticated(true)
      } else {
        setError('密碼錯誤，請再試一次')
        setPassword('')
      }
    } catch {
      setError('驗證失敗，請稍後再試')
    } finally {
      setVerifying(false)
    }
  }

  if (loading) return null

  if (authenticated) return <>{children}</>

  return (
    <div className="admin-root min-h-screen flex items-center justify-center px-4">
      <form
        onSubmit={handleSubmit}
        className="admin-card w-full"
        style={{ maxWidth: 400, padding: 32 }}
      >
        <div className="text-center mb-6">
          <div
            aria-hidden="true"
            style={{ fontSize: 48, lineHeight: 1, marginBottom: 12 }}
          >
            🔒
          </div>
          <h1 className="admin-h2 mb-2">咪室後台</h1>
          <p className="admin-callout">請輸入密碼以進入管理系統</p>
        </div>

        <label
          className="admin-subhead block mb-2"
          htmlFor="admin-password"
          style={{ color: 'var(--admin-text-secondary)' }}
        >
          管理員密碼
        </label>
        <input
          id="admin-password"
          type="password"
          value={password}
          onChange={(e) => {
            setPassword(e.target.value)
            setError('')
          }}
          placeholder="請輸入後台密碼"
          aria-label="管理員密碼"
          className="admin-input"
          autoFocus
        />

        {error ? (
          <p
            className="admin-footnote mt-3"
            role="alert"
            style={{ color: 'var(--admin-danger)', fontWeight: 500 }}
          >
            {error}
          </p>
        ) : null}

        <button
          type="submit"
          disabled={verifying || !password}
          className="admin-btn admin-btn--primary mt-6"
          style={{ width: '100%' }}
        >
          {verifying ? '驗證中…' : '進入後台'}
        </button>
      </form>
    </div>
  )
}
